import {
    httpGetPatientEvents,
    HttpGetPatientEventsOptions,
    HttpGetPatientEventsResponse
} from '@/features/patients/services/patients.http.ts'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {useEffect, useState} from 'react'
import {QUERY_KEYS} from '@/queryClient.ts'
import {PaginationResponse} from '@/types.ts'

export const useGetPatientEvents = (
    urlParams: HttpGetPatientEventsOptions['urlParams'],
    params: HttpGetPatientEventsOptions['params'],
    payload?: HttpGetPatientEventsOptions['payload'],
    options?: Omit<UseQueryOptions<HttpGetPatientEventsResponse>, 'queryKey' | 'queryFn'>
) => {
    const [persistedPagination, setPersistedPagination] = useState<PaginationResponse>({
        total: 0,
        lastPage: 1,
        perPage: 50,
        currentPage: 1
    })

    const query = useQuery({
        queryKey: [QUERY_KEYS.PATIENT_EVENTS, urlParams, params, payload],
        queryFn: () => httpGetPatientEvents({urlParams, params, payload}),
        ...options
    })

    useEffect(() => {
        if (query.isSuccess) {
            setPersistedPagination(query.data.meta)
        }
    }, [query.data?.data.length])

    return {...query, persistedPagination}
}
